import { SxProps } from '@mui/material';
import { useKaziNavigate } from '../../../Hooks/useKaziNavigate';
import { useUser } from '../../../Hooks/useUser';
import { IMarketplaceJob } from '../../../Types/Job';
import { KaziAvatar } from '../KaziAvatar';
import { KaziCard } from './KaziCard';

interface IKaziJobCard {
  job: IMarketplaceJob;
  sx?: SxProps;
}
export const KaziJobCard = ({ job, sx }: IKaziJobCard) => {
  /* ******************** Hooks ******************** */
  const { navigateWithBack } = useKaziNavigate();
  const { user } = useUser();
  /* ******************** Variables ******************** */
  const isCompany = !job?.client?.first_name && !job?.client?.last_name;

  const badge =
    user?.locator && job.applicants.includes(user.locator)
      ? 'Applied'
      : undefined;
  /* ******************** Functions ******************** */
  /* ******************** Effects ******************** */
  /* ******************** JSX ******************** */
  return (
    <KaziCard
      title={job?.title}
      subtitle={
        isCompany
          ? job.client.company
          : `${job?.client?.first_name} ${job?.client?.last_name?.substring(
              0,
              1,
            )}.`
      }
      body={job?.client?.country}
      body2={`${job?.type} · ${job?.work_site}`}
      label={`${job?.applicants?.length} applicants`}
      badge={badge}
      icon={
        <KaziAvatar
          locator={job?.client?.locator}
          first_name={job?.client?.first_name}
          last_name={job?.client?.last_name}
          company={isCompany ? job.client.company : undefined}
          width="32px"
          sx={{ fontSize: 12 }}
        />
      }
      showDivider={true}
      cardAction={() =>
        navigateWithBack(`/marketplace/posting/${job?.locator}`)
      }
    />
  );
};
